<template>
  <v-container>
    <v-row>
      <v-col>
        <v-text-field v-model="view_record.search_value" label="Search ..." append-icon="fas fa-search" outlined style="margin: 0 0 -30px 0;"></v-text-field>
      </v-col>
      <v-col md="12">
        <v-card elevation="4">
          <v-card-title>
            View Exist User
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-data-table :headers="view_record.user_header" :items="users_items" :items-per-page="5" class="elevation-1">
              <template v-slot:item.dob="{ item }">
                {{new Date(item.dob).getFullYear() + '-' + (new Date(item.dob).getMonth() + 1) + '-' + new Date(item.dob).getDate()}}
              </template>
              <template v-slot:item.edit="{ item }">
                <v-icon small @click="editData(item, 'Client')">{{item.edit}}</v-icon>
              </template>
              <template v-slot:item.delete="{ item }">
                <v-icon small @click="$store.commit('setDeleteDialogStatus', true); $store.commit('setDeleteDialogItem', item)">{{item.delete}}</v-icon>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <deleteDialog/>
    <editDialog/>
  </v-container>
</template>
<script>
import deleteDialog from '../../components/dialog/deleteDialog'
import editDialog from '../../components/dialog/editDialog'
export default {
  name: 'view_users',
  data: () => ({
    view_record: {}
  }),
  components: {
    deleteDialog,
    editDialog
  },
  created () {
    this.asyn_data()
    this.view_record = this.$store.state.viewRecord
    this.view_record.asyn_data = this.asyn_data
  },
  computed: {
    users_items () {
      return this.view_record.users_items.filter(item =>
        item.client_id.includes(this.view_record.search_value) ||
        item.MemberGTLCode.toString().includes(this.view_record.search_value) ||
        item.FamilyGTLCode.toString().includes(this.view_record.search_value) ||
        item.AgentGTLCode.toString().includes(this.view_record.search_value) ||
        item.display_name.includes(this.view_record.search_value) ||
        item.last_name.includes(this.view_record.search_value) ||
        item.first_name.includes(this.view_record.search_value) ||
        item.contact_email.includes(this.view_record.search_value) ||
        item.mobile_number.includes(this.view_record.search_value) ||
        item.wechatID.includes(this.view_record.search_value) ||
        item.dob.includes(this.view_record.search_value) ||
        item.gender.includes(this.view_record.search_value) ||
        item.nationality.includes(this.view_record.search_value) ||
        item.race.includes(this.view_record.search_value) ||
        item.weight.toString().includes(this.view_record.search_value) ||
        item.address.includes(this.view_record.search_value) ||
        item.display_lang.includes(this.view_record.search_value) ||
        this.view_record.search_value === ''
      )
    }
  },
  methods: {
    asyn_data () {
      this.$apis.readAdditionalInformation().then(res => {
        let result = []
        res.data.data.forEach(item => {
          item.edit = 'far fa-edit'
          item.delete = 'far fa-trash-alt'
          result.push(item)
        })
        this.$store.commit('setUsersItem', result)
      })
    },
    editData (item, type) {
      if (type === 'Client') {
        this.$apis.readInternalIds().then(res => {
          let result = res.data.data.find(e => e.client_id === item.client_id)
          item.internal_id = result.internal_id
          item.MemberGTLCode = result.MemberGTLCode
          item.FamilyGTLCode = result.FamilyGTLCode
          item.AgentGTLCode = result.AgentGTLCode
          item.MemberWIXID = result.MemberWIXID
          item.MemberEmailID = result.MemberEmailID
          this.$store.commit('setEditDialogClient', item)
        })
      }
      this.$store.commit('setEditDialogType', type)
    }
  }
}
</script>
